export const offersData = [
  {
    id: '1',
    title: 'Poradnia Psychologiczna',
    description:
      'Poradnia oferuje kompleksową diagnozę psychologiczną, pomoc i wsparcie psychologiczne dla osób dorosłych i ich rodzin, a także psychoterapię w nurcie systemowym, psychodynamicznym i Gestalt. W swojej pracy koncetrujemy się na rzetelnie postawionej diagnozie, na podstawie której opracowany jest plan terapii.Wspieramy w radzeniu sobie z różnorakimi kryzysami psychicznymi, a także zaopiekowujemy pacjentów chorujących onkologicznie i ich rodziny.Ponadto zajmujemy się szeroko pojętą diagnozą psychologiczną na potrzeby orzecznicze Powiatowego Zespołu ds. Orzekania o Niepełnosprawności bądź ZUS.',
    points: [
      'Wsparcie psychologiczne i  psychoterapię indywidualną',
      'Terapię rodzin i par',
      'Pomoc w trudnościach  życiowych i relacyjnych',
      'Terapię zaburzeń lękowych, depresyjnych i adaptacyjnych, innych zaburzeń psychicznych',
      'Badania funkcjonowania poznawczego, emocjonalnego i społecznego',
    ],
    tags: [
      'Konsultacje indywidualne',
      'Terapia indywidualna',
      'Terapia rodzin i par',
      'Zajęcia grupowe',
    ],
  },
  {
    id: '2',
    title: 'Poradnia Psychologiczna dla Dzieci i Młodzieży',
    description:
      'Dla dzieci w wieku przedszkolnym i szkolnym oraz młodzieży oferujemy specjalistyczne konsultacje psychologiczne pozwalające na diagnozę problematyki dziecka i jego rodziny oraz opracowanie skutecznej strategii rozwiązania trudności szkolnych, społecznych czy emocjonalnych. Zajmujemy się m.in. diagnozą w obrębie problematyki zaburzeń lękowych, depresyjnych, adaptacyjnych czy też badaniem w kierunku zaburzeń z deficytem uwagi i nadaktywnością. Wykonujemy również badania psychologiczne funkcjonowania poznawczego, a także w ramach wsparcia rozwoju motorycznego dziecka diagnozę i terapię integracji sensorycznej.Proponujemy konsultacje psychologiczne i terapię indywidualną, zajęcia grupowe/warsztatowe dla dzieci i rodziców, a także terapię rodzin.',
    points: [
      'Diagnoza problemów u dzieci w wieku przedszkolnym, szkolnym i okresie dorastania',
      'Wsparcie w trudnościach szkolnych, społecznych i emocjonalnych',
      'Badania w kierunku zaburzeń lękowych, depresyjnych i adaptacyjnych',
      'Badania w kierunku ADHD/ADD',
      'Diagnoza SI i terapia integracji sensorycznej',
      'Badania funkcjonowania poznawczego',
      'Wsparcie dla rodziców',
    ],
    tags: [
      'Terapia indywidualna',
      'Konsultacje indywidualne',
      'Wsparcie dla rodziców',
      'Terapia rodzin',
      'Zajęcia grupowe',
    ],
  },
  {
    id: '3',
    title: 'Poradnia Zdrowia Psychicznego dla Dorosłych',
    description:
      'Poradnia oferuje kompeksową pomoc w obszarze diagnozy psychologicznej i medycznej oraz psychoterapii m.in. zaburzeń adaptacyjnych, lękowych, depresyjnych czy też innych głębszych zaburzeń psychicznych oraz trudności osobowościowych.Jesteśmy placówką wspierającą klientów w radzeniu sobie z różnorakimi kryzysami psychicznymi związanymi m.in. z nagłą chorobą, wypadkiem komunikacyjnym, utratą pracy, wypaleniem zawodowym, czy stratą osoby bliskiej.W naszej pracy przede wszystkim skupiamy się na tym, co i w jakim stopniu utrudnia klientowi realne funkcjonowanie i jaka forma oddziaływania terapeutycznego będzie dla niego najkorzystniejsza.Ponadto zajmujemy się szeroko pojętą diagnozą psychologiczną i lekarską na potrzeby orzecznicze Powiatowego Zespołu ds. Orzekania o Niepełnosprawności bądź ZUS.',
    points: [
      'Konsultacje psychiatryczne',
      'Konsultacje psychologiczne i diagnostyczne',
      'Terapię indywidualną dla osób z zaburzeniami lękowymi, depresyjnymi i adaptacyjnymi',
      'Wsparcie w kryzysach życiowych i relacyjnych',
      'Pomoc w radzeniu sobie z przewlekłym stresem, przeciążeniem oraz wypaleniem zawodowym',
      'Badania funkcjonowania poznawczego (m.in. pamięć, uwaga, koncentracja)',
      'Psychoedukację w zakresie regulacji emocji i strategii radzenia sobie',
    ],
    tags: [
      'Konsultacje psychiatryczne',
      'Konsultacje indywidualne',
      'Terapia indywidualna',
      'Terapia par i rodzin',
      'Zajęcia grupowe',
      'Wsparcie kryzysowe',
    ],
  },
  {
    id: '4',
    title: 'Poradnia Logopedyczna dla Dzieci',
    description:
      'W Poradni praca logopedyczna polega na leczeniu wad wymowy, które są spowodowane różnymi czynnikami związanymi m.in. z zaburzeniami w rozwoju psychomotorycznym, niedosłuchem, budową anatomiczną w obrębie aparatu artykulacyjnego. Do nieprawidłowej mowy u dziecka mogą także przyczynić się również różnorakie anomalie zębowe bądź wady zgryzu. Logopeda diagnozuje i prowadzi dzieci z zaburzeniami ze spektrum, jąkające się czy też takie, które seplenią lub mówią niewyraźnie.',
    points: [
      'Diagnozę logopedyczną',
      'Terapię wad wymowy (seplenienie, reranie, niewyraźna mowa)',
      'Terapię jąkania',
      'Wsparcie dzieci z opóźnionym rozwojem mowy',
    ],
    tags: [
      'Konsultacje logopedyczne',
      'Terapia indywidualna',
      'Instruktaż dla rodziców i wsparcie domowe',
      'Wczesne wspomaganie rozwoju mowy',
    ],
  },
  {
    id: '5',
    title: 'Terapia Integracji Sensorycznej (SI)',
    description:
      'Integracja sensoryczna (SI) to proces neurologiczny, który umożliwia organizowanie informacji odbieranych przez zmysły, aby dziecko mogło skutecznie reagować na bodźce i funkcjonować w codziennym środowisku. Gdy proces ten jest zakłócony, mogą pojawiać się trudności w zachowaniu, nauce, koordynacji ruchowej czy komunikacji. Terapia SI, opracowana przez dr A. Jean Ayres, oferuje dzieciom możliwość poprawy funkcjonowania w wielu obszarach, wpływając pozytywnie na ich rozwój emocjonalny, społeczny i poznawczy. Terapia integracji sensorycznej opiera się na indywidualnie dobranych ćwiczeniach, które aktywizują różne zmysły dziecka: dotyk, wzrok, słuch, równowagę oraz propriocepcję, czyli odczuwanie położenia własnego ciała. Ćwiczenia mają na celu wzmocnienie zdolności dziecka do przetwarzania bodźców i przystosowania się do wymagań środowiska. Kluczową rolę w terapii odgrywa dostosowanie poziomu trudności zadań do możliwości dziecka, tak aby czuło się ono zmotywowane, ale nie przeciążone. To właśnie dzięki tej równowadze dzieci stopniowo uczą się efektywnie funkcjonować (Parham & Mailloux, 2010).',
    points: [
      'Diagnozę integracji sensorycznej',
      'Terapię SI dostosowaną do indywidualnych potrzeb dziecka',
      'Ćwiczenia wspierające równowagę, koordynację i planowanie ruchowe',
      'Wzmacnianie koncentracji i regulacji emocji',
      'Instruktaż dla rodziców i zalecenia do pracy w domu',
    ],
    tags: [
      'Konsultacje diagnostyczne',
      'Terapia indywidualna',
      'Ćwiczenia grupowe (jeżeli wskazane)',
      'Wsparcie i instruktaż dla rodziców do pracy w domu',
      'Monitorowanie postępów i dostosowanie programu terapeutycznego',
    ],
  },
];
